<template>
    <el-main style="height: 100%;">
        <div style="margin-bottom: 20px;">
            <el-input
                clearable
                v-model="sstj.czOrbh"
                placeholder="请输入测站或编号"
                style="width: 20vw;margin-right: 20px;"
            />
            <el-button type="primary" size="small" style="background-color: #a8a8a8;border: solid 0rem #f4f4f4;" @click="resetGetData">重置</el-button>
            <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="getData">搜索</el-button>
        </div>
        <div style="width: 100%;">
            <el-row v-if="szData.length > 0" :gutter="20" style="height: calc(100% - 100px);">
                <el-col :span="8" v-for="item,index in szData" :key="index">
                    <div style="width: 100%;height: 320px;background-color: #fff;padding: 12px;box-sizing: border-box;margin-bottom: 15px;">
                        <video :id="'videoPlayer' + index" muted autoplay loop controls style="width: 100%;height: 260px;"></video>
                        <!-- <video id="videoPlayer" muted autoplay loop controls style="width: 100%;height: 260px;"></video> -->
                        <div style="font-size: 16px;height: 35px;line-height: 35px;">
                            <span style="margin-right: 10px;">{{ item.stcd }}</span>
                            <span style="color: #3588d6;">{{ item.stnm }}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row v-else>
                <div style="width: 100%;text-align: center;height: 100px;font-size: 20px;">
                    暂无视频站
                </div>
            </el-row>
            <div>
                <page-footer
                    :rForm="sstj"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                >
                </page-footer>
            </div>
        </div>
        <!-- <el-dialog
            :visible.sync="spDataX.spDialogVisible"
            width="50%"
            :show-close="false"
            :close-on-click-modal="false"
        >
            <div>
                <div style="display: flex;justify-content: space-between;">
                    <div>
                        <span>图像站</span>
                    </div>
                    <el-image class="tabDelImg" :src="require('../../assets/tab-del.png')" @click="handleClose" style="cursor: pointer;"></el-image>
                </div>
                <div>
                    <span>这是一段信息</span>
                </div>
            </div>
        </el-dialog> -->
    </el-main>
</template>

<script>
// import  WebRtcStreamer from "../../../public/stactic/webrtcstreamer";

import pageFooter from "@/components/pageFooter";
import tabSwitch from "@/components/buttonGather/tabSwitch";
export default {
    components: {
        pageFooter,
        tabSwitch
    },
    data() {
        return {
            sstj:{
                czOrbh:'',
                size: 20,
                current: 1,
                total: 0,
            },
            szData:[],
            webRtcServer: null,
            webRtcServerList:[],
            
            spDataX:{
                spDialogVisible:false,
            },
        }
    },
    mounted() {
        this.getData();
    },
    beforeDestroy() {
        if(this.webRtcServerList.length > 0 ){
            for (let i = 0; i < this.webRtcServerList.length; i++) {
                this.webRtcServerList[i].disconnect();
            }
            this.webRtcServerList =[];
        }
    },
    watch: {
        "$store.state.head.skCd"() {
            this.getData();
        }
    },
    methods: {
        getData() {
            const data = {
                ...this.sstj,
            };
            this.request.get("/rm-bvideo/queryVideoPage",{ params: data }).then((res) => {
                if (res.ok) {
                    this.szData = res.data.records;
                    this.sstj.total = res.data.total;
                    this.$nextTick(function() {
                        this.initWevRtcVideo();
                    });
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        initWevRtcVideo(){
            for (let i = 0; i < this.szData.length; i++) {
                this.webRtcServer = new WebRtcStreamer("videoPlayer"+i,"http://127.0.0.1:8000");
                this.webRtcServer.connect(this.szData[i].path);
                this.webRtcServerList.push(this.webRtcServer);
            }
            // this.webRtcServer= new WebRtcStreamer("videoPlayer","http://127.0.0.1:8000");
            // this.webRtcServer.connect("rtsp://rtspstream:7447c0a888008f7367e99ce338ab82ce@zephyr.rtsp.stream/pattern");
        },
        resetGetData(){
            this.sstj = {
                czOrbh:'',
                size: 20,
                current: 1,
                total: 0,
            }
            this.getData();
        },
        // 切换分页
        currentChange(val) {
            this.sstj.current = val;
            this.getData();
        },
        // 显示最大条数变动
        sizeChange(val) {
            this.sstj.size = val;
            this.getData();
        },
        // handleOpen(){
        //     this.spDataX.spDialogVisible = true;
        // },
        // handleClose() {
        //     this.spDataX.spDialogVisible = false;
        // },
    },
}
</script>
<style scoped>
.bcbc{
    cursor: pointer;
    padding: 6px 20px;
    border-radius: 5px;font-size: 16px;
    margin-right: 20px;
}
.bcbca{
    background-color: #fff;
    color: #000;
}
.bcbcb{
    background-color: #6aa9f6;
    color: #fff;
}
.cece{
    color: #000;
    font-size: 16px;
    background-color: #fbfbfb;
    padding: 15px 10px;
    vertical-align: middle;
}

.btys {
    height: 100%;
    width: 100%;
}

/*去除头部*/
::v-deep .el-dialog__header{
    display: none;
}
.tabDelImg {
    width: 3rem;
    height: 3rem;
}
::v-deep .el-dialog__body {
    padding: 20px;
}
</style>